export const plansData = [
    {
      id: 1,
      fileName: "heartplus.png",
      name: "BASIC PLAN",
      price: "25",
      features: [
        "2 hours of excercises",
        "Free consultaion to coaches",
        "Access to The Community",
      ],
    },
    {
      id: 2,
      fileName: "crown.png",
      name: "PREMIUM PLAN",
      price: "30",
      features: [
        "5 hour of excercises",
        "Free consultaion of Coaches",
        "Accessto minibar",
      ],
    },
    {
      id: 3,
      fileName: "dumbell.svg",
      name: "PRO PLAN",
      price: "45",
      features: [
        "8 hours of excercises",
        "Consultation of Private Coach",
        "Free Fitness Merchandises",
      ],
    },
  ];